// extracted by mini-css-extract-plugin
export default {"card":"multiDailyMentions_card__9Ega5","title":"multiDailyMentions_title__pqW56"};